import { render, staticRenderFns } from "./AUserDetailStaff.vue?vue&type=template&id=0f246b00&scoped=true"
import script from "./AUserDetailStaff.vue?vue&type=script&lang=js"
export * from "./AUserDetailStaff.vue?vue&type=script&lang=js"
import style0 from "./AUserDetailStaff.vue?vue&type=style&index=0&id=0f246b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f246b00",
  null
  
)

export default component.exports